import { Button, Tooltip, CircularProgress, useTheme } from '@mui/material';
import React from 'react';
import './Button.scss';

function UnifiedButton({
    backgroundColor,
    fontColor,
    hoverBackgroundColor,
    hoverFontColor,
    hoverColor,
    width,
    onClick,
    textContent,
    className,
    borderColor,
    tooltip,
    icon,
    disabled,
    type,
    loader
}) {
    const theme = useTheme();
    const buttons = theme.buttonProperties;

    const buttonClassName = `${className || ''} custom-button`;

    return (
        <Tooltip title={tooltip ? tooltip : ""} disableInteractive>
            <Button
                variant="contained"
                size="large"
                disabled={disabled}
                type={type}
                sx={{
                    borderRadius: buttons.buttonradius,
                    minWidth: width ? width : buttons.minWidth,
                    padding: buttons.buttonpadding,
                    textTransform: buttons.texttransform,
                    boxShadow: buttons.boxshadow,
                    color: fontColor ? fontColor : buttons.buttontextcolor,
                    height: buttons.buttonHeight,
                    lineHeight: buttons.buttonlineheight,
                    display: buttons.buttondisplay,
                    alignItems: buttons.buttonalignitems,
                    fontWeight: buttons.buttonFontWeight,
                    fontFamily: buttons.buttonFontFamily,
                    backgroundColor: backgroundColor ? backgroundColor : buttons.btnBackground,
                    border: `1px solid ${borderColor ? borderColor : buttons.buttonborder}`,
                    overflow: 'hidden',
                    '&:hover': {
                        backgroundColor: hoverBackgroundColor || hoverColor || 'grey', // Default hover background color
                        color: hoverFontColor || (fontColor === 'white' ? 'black' : 'white'), // Default hover text color
                        boxShadow: '0 15px 25px rgba(0, 0, 0, 0.2)', // Add hover box shadow
                    },
                }}
                className={buttonClassName}
                onClick={onClick}
            >
                {loader ? <CircularProgress size={24} sx={{ color: 'white' }} /> : icon}
                {loader ? null : textContent}
            </Button>
        </Tooltip>
    );
}

export default UnifiedButton;
